import PropTypes from "prop-types"
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const ConfirmModal = ({
  isOpen,
  toggle,
  title,
  message,
  confirmLabel = "Confirm",
  onConfirm,
  isConfirming = false,
  icon = "mdi-help-circle-outline",
  btnColor = "primary",
}) => {
  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={toggle}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className={`avatar-title bg-${btnColor} text-${btnColor} bg-opacity-10 font-size-20 rounded-3`}>
              <i className={`mdi ${icon}`}></i>
            </div>
          </div>
          {title && (
            <h5 className="mb-2">{title}</h5>
          )}
          <p className="text-muted font-size-16 mb-4">{message}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className={`btn btn-${btnColor}`}
              onClick={onConfirm}
              disabled={isConfirming}
            >
              {isConfirming ? "Please wait..." : confirmLabel}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={toggle}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  isConfirming: PropTypes.bool,
  icon: PropTypes.string,
  btnColor: PropTypes.string,
}

export default ConfirmModal
